import { useTranslation } from "react-i18next";

export default function AuthPassword({ children }) {
  const { t } = useTranslation();

  return (
    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 position-fixed" style={{ color: "white", textAlign: "center" }}>
      <div className="password-criteria">
        <h5 className="primary-title" style={{ color: "white" }}>
          {t("pages.changePassword.tips", {
            defaultValue: "New Password Criteria Tips",
          })}
        </h5>
        <div className="change-list text-start" style={{ fontSize: "15px" }}>
          <ul className="my-3 mx-3 ">
            <li className="mb-2">
              {t("pages.changePassword.Password_length", {
                defaultValue:
                  "Password length should not be less than 6 and not more than 16 characters.",
              })}
            </li>
            <li className="mb-2">
              {t("pages.changePassword.password_allow", {
                defaultValue:
                  "Password should contain at least one digit [0-9], one alphabet [A-Z] [a-z] and one special character such as  [@#&*!].",
              })}
            </li>
            <li className="mb-2">
              {t("pages.changePassword.password_avoid", {
                defaultValue:
                  "Please avoid choosing a password that is generic in nature, guessable or inferable.",
              })}
            </li>
            <li className="mb-2">
              {t("pages.changePassword.password_avoid_relate", {
                defaultValue:
                  "Avoid password that is related to your personal data such as name, date of birth, address, telephone number and car or bike registration number.",
              })}
            </li>
            <li className="mb-2">
              {t("pages.changePassword.password_memorize", {
                defaultValue:
                  "It is a good practice to memorize your password rather than write it down somewhere.",
              })}
            </li>
            <li>
              {t("pages.changePassword.security_reasons", {
                defaultValue:
                  "For security reasons, keep changing your password at regular intervals.",
              })}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
